import React  from 'react'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'

export function NextCardButton(props){
    const {
        setUdCard
    } = props

    const associatedCards = decodeStorage('associatedCards')
    const cardending = decodeStorage('cardending')

    const handleNextTarjetas = () => {
        let poicitionCard = associatedCards.findIndex(cosa => cosa.card_ending === cardending)

        if(poicitionCard < (associatedCards.length -1)){
            encodeStorage('cardending', associatedCards[poicitionCard +1].card_ending)
            encodeStorage('sears_numero_internet', associatedCards[poicitionCard +1].no_internet)
            setUdCard(true)
        }else{
            encodeStorage('cardending', associatedCards[0].card_ending)
            encodeStorage('sears_numero_internet', associatedCards[0].no_internet)
            setUdCard(true)
        }
    };

    return(
        associatedCards &&
            associatedCards.length >= 2 &&
                <div className="arrowCards" onClick={handleNextTarjetas}></div>
        
    )
}